import React from 'react';

import MuiAccordionDetails, {
  AccordionDetailsProps as MuiAccordionDetailsProps,
} from '@mui/material/AccordionDetails';
import clsx from 'clsx';

import { CoreProps } from '../../types';
import { withCoreProps } from '../../withCoreProps';

export const AccordionDetails = withCoreProps<AccordionDetailsProps>(
  ({
    children,
    className,
    ...props
  }: React.PropsWithChildren<AccordionDetailsProps>) => {
    const clsxClass = clsx(className);

    return (
      <MuiAccordionDetails {...props} className={clsxClass}>
        {children}
      </MuiAccordionDetails>
    );
  },
);

export interface AccordionDetailsProps
  extends MuiAccordionDetailsProps,
    CoreProps {}
